import { atom } from "jotai";
import { type AccountEntity } from "@/api/__generated__/orval/accounts";
import { accountsAtom } from "./accounts";
import { currentAccountIdAtom } from "./currentAccountId";

export const currentAccountAtom = atom<AccountEntity | undefined>((get) => {
  const accounts = get(accountsAtom);
  const currentAccountId = get(currentAccountIdAtom);

  return accounts.find((a) => a.id === currentAccountId);
});
